import { memo, useCallback, useState } from "react";
import { useTranslate } from "helpers";
import { Button } from "ui/components/Button/Button";
import VehicleEditCard from "../../../VehicleDetailCard/components/VehicleEditCard/VehicleEditCard";

interface VehicleEditActionProps {
  vehicleId: string;
}

const VehicleEditAction: React.FC<VehicleEditActionProps> = ({ vehicleId }) => {
  const { t } = useTranslate();

  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditSuccess = useCallback(() => {
    setShowEditModal(false);
  }, []);

  return (
    <>
      <Button
        variant="primary"
        children={t("admin.change")}
        onClick={() => setShowEditModal(true)}
        startIcon="/media/icons/plus.svg"
      />

      <VehicleEditCard
        vehicleId={vehicleId}
        show={showEditModal}
        onSuccess={handleEditSuccess}
        onClose={() => setShowEditModal(false)}
      />
    </>
  );
};

export default memo(VehicleEditAction);
